import { FC } from "react";
import { StaticInfo } from "../../parts/StaticInfo";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";


export const AboutModelPage: FC = () => {

  interface Props {
    taste: string;
    checkPoint: string;
    url: string;
    linkText: string;
  }
  
  const ModelSection: FC<Props> = ({ taste, checkPoint, url, linkText }) => {
    return (
      <div className="flex justify-start py-4 border-b border-gray-200">
        <span className="w-[240px]">{taste}</span>
        <span className="w-[320px]">{checkPoint}</span>
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img src="/images/civitai-color.png" className="h-[20px] w-[20px]" />
        </a>
      </div>
    );
  };
  
  return <>
    <Helmet>
      <title>モデルテイストについて - Drop AI</title>
      <meta name="description" content="Drop AIで利用しているモデルのテイストについてご案内しています。" />

      <meta property="og:url" content="https://drop4i.com/about-model" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="モデルテイストについて - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIで利用しているモデルのテイストについてご案内しています。" />
    </Helmet>
    <PageSection title="Drop AIのモデルテイストについて">
      <div className="mb-6">
        Drop AIの画像生成に用いられているモデルのテイストは以下のcheckpointを参照しております。<br/>
        画像生成の方針についてはcheckpointのポリシーを必ず参照ください
      </div>
      <div className="max-w-[900px] mx-auto">
        <div className="flex justify-start mb-4">
          <span className="w-[240px] text-[#868E96] font-bold">モデルのテイスト</span>
          <span className="w-[320px] text-[#868E96] font-bold">モデル</span>
          <span className="text-[#868E96] font-bold">参照</span>
        </div>

        <ModelSection taste="デフォルト" checkPoint="SD XL" url="https://civitai.com/models/101055/sd-xl?modelVersionId=128078" linkText="CIVITAI" />
        <ModelSection taste="アニメ" checkPoint="blue_pencil-XL" url="https://civitai.com/models/119012/bluepencil-xl" linkText="CIVITAI" />
        <ModelSection taste="イラスト" checkPoint="_CHEYENNE_" url="https://civitai.com/models/198051/cheyenne" linkText="CIVITAI" />
        <ModelSection taste="リアリスティック" checkPoint="CyberRealistic XL" url="https://civitai.com/models/312530/cyberrealistic-xl" linkText="CIVITAI" />
        <ModelSection taste="リアリスティック" checkPoint="ArienMixXL Asian portrait 亚洲人像" url="https://civitai.com/models/118913/sdxl-10-arienmixxl-asian-portrait" linkText="CIVITAI" />
        <ModelSection taste="アニメ" checkPoint="Reproduction | SDXL" url="https://civitai.com/models/118729/reproduction-or-sdxl?modelVersionId=240824" linkText="CIVITAI" />
        <ModelSection taste="リアリスティック" checkPoint="fuduki_mix" url="https://civitai.com/models/129830/fudukimix?modelVersionId=266180" linkText="CIVITAI" />
        <ModelSection taste="ピクセルアート" checkPoint="Pixel XL" url="https://civitai.com/models/173422/pixel-xl" linkText="CIVITAI" />
        <ModelSection taste="景色" checkPoint="Better than words" url="https://civitai.com/models/149359/better-than-words?modelVersionId=233092" linkText="CIVITAI" />
      </div>
    </PageSection>
  </>;
}